module.exports = __webpack_public_path__ + "img/38400.677cf6c2.jpg";